import { gql } from "@apollo/client";

export const GET_CONFIG = gql`
  query GetConfigResolver {
    getConfigResolver {
      currencies {
        _id
        name
        symbol
        isDefault
      }
      locations {
        _id
        nombre
        isDefault
      }
      paymentMethods {
        _id
        name
        key
      }
      concepts {
        _id
        description
        name
        key
      }
      classrooms {
        _id
        maxCapacity
        name
      }
      withdrawalReasons {
        _id
        name
      }
      accountingBoxes {
        _id
        createdAt
        name
        description
        abHistoryId
        isTesoreria
      }
      areas {
        _id
        description
        name
        key
      }
    }
  }
`;
